export default "__VITE_ASSET__cx3CKIFJ__"